/**
 * Utility functions
 */

export {
    formatNumber,
    formatCurrency,
    formatCurrencyCompact,
    formatPercent,
    truncateAddress,
    formatTokenNumber,
    formatNumberSignificantDigits,
    safeToNumber
} from "./format";

export { formatBalance, formatEarnings } from "./formatBalance";

// Staking-program constants — moved from apps/main
// (`@/services/staking/staking-program`) as part of the Phase 1F
// shared-widget hoist.
export { DEFAULT_SALT, TOKEN_DECIMALS } from "./stakingProgram";

export { DEFAULT_APY_CEILING, formatAdvertisedApy, resolveAdvertisedApy } from "./apy";

export {
    safeParseNumber,
    safeParseString,
    safeParseDate,
    safeFormatPercent,
    safeCalculatePercent
} from "./safeDataParsing";

export { getTokenMetadata, getTokenMetadataSync } from "./tokenMetadata";
export type { TokenMetadata } from "./tokenMetadata";

export { convertAssetToSelectOption, getAssetDecimals, type SelectOption } from "./tokenHelpers";
export {
    convertTokenToRaw,
    convertStringtoRaw,
    convertRawToToken,
    toRawAmount,
    fromRawAmount
} from "./tokenConversions";

export { isValidBigDecimal, isZero, isNegative } from "./bigdecimal";

export { confirmTransaction } from "./confirmTransaction";
export type { ConfirmTransactionOptions, ConfirmTransactionResult } from "./confirmTransaction";

export { isProductionHost, detectDeployEnv } from "./environment";
export type { DeployEnv } from "./environment";

export { cn } from "./cn";

export { collapseStyle } from "./collapseStyle";

export { easings } from "./easings";
export type { EasingTuple } from "./easings";

export { copyText } from "./copyText";
export type { CopyTextResult } from "./copyText";

export { describeInvitationAccess, getInvitationExpiryState, invitationStatusLabel } from "./invitationExpiry";
export type { InvitationExpiryState } from "./invitationExpiry";

export { isValidAddress, SolanaAddress, EvmAddress } from "./address";
export type { AddressChain, SolanaAccountSummary, TokenAddressKind } from "./address";
